// Define permissions using an enum

export enum Access {
	Write = 'write',
	Read = 'read',
	Verify = 'verify',
	VerifyOwn = 'verify-own'
}
